import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './Submit.module.scss';

// TODO: title presunout do children, htmlTitle vyhodit
const Submit = forwardRef(({
  title,
  htmlTitle,
  className,
  iconClassName,
  onClick,
  disabled,
  processing,
  noMargin,
  fullWidth,
  ...props
}, ref) => (
  <button
    ref={ref}
    disabled={disabled || processing}
    className={cn(
      styles.submit,
      className,
      {
        [styles.processing]: processing,
        [styles.hasIcon]: !!iconClassName,
        [styles.noMargin]: noMargin,
        [styles.fullWidth]: fullWidth,
      }
    )}
    type="submit"
    title={htmlTitle}
    onClick={onClick}
    {...props}
  >
    {iconClassName && !processing && (<i className={iconClassName} />)}
    {processing && (<div className={cn('spinner-border text-light', styles.spinner)} />)}
    <span>{title}</span>
  </button>
));

Submit.displayName = 'forwardRef(Submit)';

Submit.propTypes = {
  title: PropTypes.node.isRequired,
  htmlTitle: PropTypes.string,
  className: PropTypes.string,
  iconClassName: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  processing: PropTypes.bool,
  fullWidth: PropTypes.bool,
};

Submit.defaultProps = {
  className: '',
  htmlTitle: null,
  iconClassName: null,
  onClick() {},
  disabled: false,
  processing: false,
  fullWidth: false,
};

export default Submit;
